import {t} from '../../../../common/getTranslations';
import {requestContext} from '../../../../common/requestContext';
import {formatWithCommas} from '../../../../common/shared/utils/formatWithCommas';
import {Grid} from '../../../../design-system/atoms/Grid/Grid';
import {Text} from '../../../../design-system/atoms/Text/Text';
import {ListViewGroup} from '../../../../graphql/generated/types';
import {CommonGroupProps} from '../../type';

export function NormalList({children, group}: CommonGroupProps) {
  const {isMobile} = requestContext.requestInfo.display;
  // 오늘 신작, 오늘 UP에서만 사용되는 데이터 입니다.
  const {meta} = group as ListViewGroup;

  return (
    <>
      {meta && (
        <div className="flex h-48pxr w-full items-center justify-between px-15pxr">
          {meta.title && (
            <Text className="font-large4-bold text-theme-solid-100">
              {meta.title}
            </Text>
          )}
          {meta.count && (
            <Text className="font-small2 text-theme-solid-40">
              {t('landing_new_content_series_count', {
                values: {
                  value: formatWithCommas(meta.count),
                },
              })}
            </Text>
          )}
        </div>
      )}
      <Grid cols={isMobile ? 1 : 2} tabletCols={2}>
        {children}
      </Grid>
    </>
  );
}
